import React from 'react';
import cars01 from '../../assets/img/cars01.png';
import searchicon from '../../assets/img/searchicon.png';
import speedometer from '../../assets/img/speedometer.svg';
import gasolinePump from '../../assets/img/gasoline-pump.svg'
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import { useHistory, useParams } from "react-router-dom";
import API from "../../Services/BaseService";
import { useState } from 'react';
import { useEffect } from 'react';
import UrCarAction from './UrCarAction';
import { useDispatch, useSelector } from 'react-redux';
import Loading from "../../Component/Loading/Loading";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import printJS from 'print-js';
import Popup from "../../Component/Popup/Popup";
import AcceptedCars from "../../Container/Carlist/AcceptedCars";
import Datetime from 'react-datetime';
import moment from 'moment';
import wrong from '../../assets/img/wrong.png';
import PageNotFound from '../FallBackUI/PageNotFound';
import DealerAction from '../DealerRedux/DealerAction';
import ls from "local-storage";
import odometer from '../../assets/img/miles.jpg';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import UrCarBidList from "./../../Container/UrCardetails/UrBidlist";
import SealedBidHome from './../../Container/UrCardetails/SealedBidHome';
import _ from 'lodash';
import Pagination from "../Pagination";
import 'bootstrap/dist/css/bootstrap.min.css';
import { OverlayTrigger, Popover, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from '@fortawesome/free-solid-svg-icons';
const URcar = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  console.log("loading", loading);
  const dispatch = useDispatch();
  const dealerData = useSelector(state => state.DealerReducer.payload);
  const pageLimit = 5;


  const CustomPrevArrow = (props) => (
    <button {...props} className="custom-prev-arrow">
      &lt; {/* Left arrow */}
    </button>
  );

  const CustomNextArrow = (props) => (
    <button {...props} className="custom-next-arrow">
      &gt; {/* Right arrow */}
    </button>
  );



  const responsiveSettings = [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
  ];

  const [Searchloading, setSearchloading] = useState(false);
  const [soldCarDetail, setSoldCarDetail] = useState();
  const [carDetail, setCarDetail] = useState([]);
  const [carDetailForExcel, setCarDetailForExcel] = useState([]);
  const successData = useSelector(state => state.LoginReducer.payload);
  const [VINNumber, setVINNumber] = useState("");
  const [InventoryNo, setInventoryNo] = useState("");
  const [billOfSale, setBillOfSale] = useState("");
  const [titlestatus, setTitleStatus] = useState("");
  const [gatepasscode, setGatePassCode] = useState("");
  const [buyerDealerId, setBuyerDealerId] = useState([]);


  const yesterday = moment().subtract(1, 'day');
  const disablePastDt = current => {
    return current.isAfter(scheduleDate);
  };

  const [year, setYear] = useState("");
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [activecar, setActivecar] = useState("");
  const [bidStatus, setBidStatus] = useState("");

  const [status, setStatus] = useState("");
  const [urCarDetailLength, setUrCarDetailLength] = useState("");

  const [vinError, setVinError] = useState("");
  const [scheduletodate, setScheduleToDate] = useState("");
  const [scheduleDate, setScheduleDate] = useState("");
  const [fromDateError, setFromDateError] = useState("");
  const [loadMore, setLoadMore] = useState(8)
  const [loadMoreSearch, setLoadMoreSearch] = useState(8)
  const [loadMoreSold, setLoadMoreSold] = useState(8)
  const [urCarCount, seturCarCount] = useState([]);
  const [urCarDetailsCount, setUrCarDetailsCount] = useState(false);
  const [urCarSearchCount, setUrCarSearchCount] = useState("");
  const [urCarRefresh, setUrCarRefresh] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [carId, setCarId] = useState(null);
  const [allCarMultiAcceptEnable, setAllCarMultiAcceptEnable] = useState(false)
  const [allCarAcceptAllEnable, setAllCarAcceptAllEnable] = useState(false)
  const [dealername, setDealerName] = useState("");

  const [checkedCarId, setCheckedCarId] = useState([]);
  const [highBid, setHighBid] = useState([]);
  const [buyerId, setBuyerId] = useState([]);
  const [isOpenAccept, setIsOpensAccept] = useState(false);
  const [checkedCars, setCheckedCars] = useState([]);
  const [dealerList, setDealerList] = useState("");
  const [sellerList, setSellerList] = useState("");
  const [dealerId, setDealerId] = useState("");
  const [selectedSellerDetails, setSelectedSellerDetails] = useState("");
  const [flagFilter, setFalgFilter] = useState(false);
  const [selectSellerId, setselectSellerid] = useState("");

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false)
  const [transportationCharge, setTransportationCharge] = useState([]);

  const backUrl = ls.get("backredirection");
  const back = backUrl[(backUrl.length) - 1];
  const [isOpenBidList, setisOpenBidList] = useState(false);
  const [isOpenCarHistory, setIsOpenCarHistory] = useState(false);
  const [bidId, setBidId] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(ls.get("currentpageopen1") || 1);
  const [searchFlag, setSearchFlag] = useState(false);
  const [searchFlag1, setSearchFlag1] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  const handleSelect = () => {
    setHighBid("")
    setCheckedCarId("")
  }

  const MultiAcceptDisable = () => {
    setAllCarMultiAcceptEnable(false)
  }
  const AllAcceptDisable = () => {
    setAllCarAcceptAllEnable(false)
  }
  const togglePopupAccept = () => {
    setIsOpensAccept(!isOpenAccept);
  }
  const handleClose1 = () => {
    setIsOpensAccept(!isOpenAccept);
    getcar(dealerData);

  }
  const AllCarSelectBox = (AllcarsData) => {
    const Allnewsvalue = AllcarsData.filter(data => data.status !== "sold" && data.high_bid !== "" && data.high_bid !== null && data.high_bid !== undefined && data.high_bid !== 0 && data.isActive !== 0 && data.label_type !== "Sealed Bid Sales")
    setAllCarMultiAcceptEnable(false);
    setAllCarAcceptAllEnable(true)
    setBuyerDealerId(Allnewsvalue.map(data => data.buyer_id))

    setCheckedCarId(Allnewsvalue.map(data => data.carid))
    setHighBid(Allnewsvalue.map(data => data.high_bid))
    setBuyerId(Allnewsvalue.map(data => data.buyer_dealer_id))
    setTransportationCharge(Allnewsvalue.map(data => data.transportation_charge))

  }

  const allCarSelectBox = (id, carData) => {
    const newvalue = document.getElementById(id).checked ? [...checkedCars, carData] : checkedCars.filter(data => data.carid !== carData.carid)
    setCheckedCars(document.getElementById(id).checked ? [...checkedCars, carData] : checkedCars.filter(data => data.carid !== carData.carid))

    setCheckedCarId(newvalue.map(data => data.carid))
    setHighBid(newvalue.map(data => data.high_bid))
    setBuyerId(newvalue.map(data => data.buyer_dealer_id))
    setBuyerDealerId(newvalue.map(data => data.buyer_id))
    setTransportationCharge(newvalue.map(data => data.transportation_charge))
    setBuyerDealerId(newvalue.map(data => data.buyer_id))


  }

  const dataSet1 = [
    {
      name: "Johson",
      amount: 30000,
      sex: 'M',
      is_married: true
    },
    {
      name: "Monika",
      amount: 355000,
      sex: 'F',
      is_married: false
    },
    {
      name: "John",
      amount: 250000,
      sex: 'M',
      is_married: false
    },
    {
      name: "Josef",
      amount: 450500,
      sex: 'M',
      is_married: true
    }
  ];


  const getcar = (data) => {
    let request = {

      // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data ,
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,


      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
      rowsPerPage: 5,
      page: currentPage,
    }
    API.post('seller_urcar/condition', request).then(res => {
      // const {results} = res.data.data;
      //if(results.length>0){

      if (res.data.success === true) {
        // setCarDetail(res.data.data);

        const records = res.data.data

        setCarDetail(records);
        setTotalPages(Math.ceil(res.data.data1[0].count / 5));
        setTotalRecords([...Array(Math.ceil(res.data.data1[0].count / 5) + 1).keys()].slice(1))

        setLoadMore(res.data.data.length >= 8 ? res.data.data.length + 8 : loadMore)
        setUrCarDetailLength(res.data.data.length)
        setDealerName(res.data.data[0]?.dealer_name);

        // setUrCarRefresh(false);


        if (res.data.data.length > 0) {
          // 
          setCarDetailForExcel(res.data.data.map(value => {
            return {
              vin_no: value.vin_no,
              model: value.model,
              make: value.make,
              year: value.year
            }
          }))
        }

        setLoading(false);
        //}
        //setrecentCarFlag(!recentCarFlag)
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
        setLoading(false);
      }
    });
  }

  const getFiltercar = (data) => {
    let request = {

      // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data ,
      seller_dealer_id: data.seller_dealer_id,

      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
      rowsPerPage: 5,
      page: currentPage,
    }
    API.post('seller_urcarFilter/condition', request).then(res => {
      // const {results} = res.data.data;
      //if(results.length>0){

      if (res.data.success === true) {
        // if (!vinNo && !carId && !sellerId && !filterName) {
        //   setSearchFlag(false)
        // }

        const totalCount = res.data.data.length;
        const newTotalPages = Math.ceil(totalCount / pageLimit);
        let newCurrentPage = currentPage;
        if (newCurrentPage > newTotalPages) {
          newCurrentPage = newTotalPages;
        }
        const startIndex = (newCurrentPage - 1) * pageLimit;
        const endIndex = Math.min(currentPage * pageLimit, totalCount);

        const records = res.data.data
        setCarDetail(records);
        setTotalPages(Math.ceil(res.data.data1[0].count / 5));
        setTotalRecords([...Array(Math.ceil(res.data.data1[0].count / 5) + 1).keys()].slice(1))



        // setCarDetail(res.data.data);
        setLoadMore(res.data.data.length >= 8 ? res.data.data.length + 8 : loadMore)
        setUrCarDetailLength(res.data.data.length)
        // setUrCarRefresh(false);


        if (res.data.data.length > 0) {
          // 
          setCarDetailForExcel(res.data.data.map(value => {
            return {
              vin_no: value.vin_no,
              model: value.model,
              make: value.make,
              year: value.year
            }
          }))
        }

        setLoading(false);
        //}
        //setrecentCarFlag(!recentCarFlag)
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
        setLoading(false);
      }
    });
  }

  const getsoldcar = (data) => {
    let request = {
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

      // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data ,


      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
      key: loadMoreSold
    }
    API.post('recentlysoldcars/condition', request).then(res => {
      // const {results} = res.data.data;
      //if(results.length>0){

      if (res.data.success === true) {

        setSoldCarDetail(res.data.data[0].transportation_flag);
        // console.log("transporation_f",res.data.data[0].transportation_flag)
        setLoadMoreSold(res.data.data.length >= 8 ? res.data.data.length + 8 : loadMoreSold)
        if (res.data.data.length > 0) {
          setCarDetailForExcel(res.data.data.map(value => {
            return {
              vin_no: value.vin_no,
              model: value.model,
              make: value.make,
              year: value.year
            }
          }))
        }
        // setLoading(false);
        //}
        //setrecentCarFlag(!recentCarFlag)
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }

    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
      }
    });
  }
  const rerunCarPage = (pathid, seller_data, seller_dealer_id) => {
    // console.log("seller_dealer_id+++++",seller_dealer_id)
    dispatch(UrCarAction.sellerid(seller_data, seller_dealer_id))
    // history.push("/reRunEditdetails/"+pathid);
    history.push({
      pathname: "/reRunEditdetails",
      state: { backURL: "/urcar", id: pathid, sellerId: seller_dealer_id },
    });
  }
  const soldredirectpage = (pathid, seller_data, title_status_name) => {
    // console.log("seller_dealer_id+++++",seller_dealer_id)
    dispatch(UrCarAction.sellerid(seller_data))
    // history.push("/cardetails/"+pathid);
    history.push({
      pathname: "/soldcardetails",
      state: { backURL: "/carlist", id: pathid, titlesold: title_status_name }
    });
  }
  useEffect(() => {
    // getcar();
    getsoldcar(dealerData);
  }, [scheduletodate, scheduleDate, dealerData]);

  const redirectpage = (pathid, seller_data, seller_dealer_id, transportation_flag) => {
    // console.log("seller_dealer_id+++++",seller_dealer_id)
    dispatch(UrCarAction.sellerid(seller_data))
    if (seller_data.status === "sold") {


      // history.push("/cardetails/"+pathid);
      history.push({
        pathname: "/soldcardetails",
        state: { backURL: "/urcar", id: pathid, transportationFlag: transportation_flag, sellerDealerId: seller_dealer_id }
      });
      ; ls.set("backredirection", [...backUrl, "/urcar"])
    }
    else {
      history.push({
        pathname: "/cardetails",
        state: { backURL: "/urcar", id: pathid, sellerDealerId: seller_dealer_id }
      });
      ; ls.set("backredirection", [...backUrl, "/urcar"])

      // console.log("sellerDealerId test123", seller_dealer_id);

    }
  }

  const searchCarDetail = (data, flag) => {
    // setVinError("")
    setFromDateError("")
    // if (VINNumber.length > 0 && VINNumber.length < 6) {
    //   setVinError("VIN number must have last 6 digit")
    //   return;
    // }
    // else if (VINNumber.length > 6) {
    //   setVinError("VIN number accept only last 6 digit")
    //   return;
    // }
    if (scheduletodate) {
      if (!scheduleDate) {
        setFromDateError("From Date is required")
        return;
      }
    }
    if (scheduleDate) {
      if (!scheduletodate) {
        setFromDateError("To Date is required")
        return;
      }
    }
    let request = {
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

      // seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id :data.seller_dealer_id,


      make: make,
      model: model,
      year: year,
      vin_no: VINNumber,
      car_id: InventoryNo,
      status: status == "Select" ? "" : status,

      // style: style,
      // active : activecar =="" ? "":Number(activecar),
      active: activecar == "Select" ? "" : activecar,
      sales_type: bidStatus == "Select" ? "" : bidStatus,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
      fromdate: scheduleDate,
      todate: scheduletodate,
      // fromdate: scheduleDate == null ? "" : convert(scheduleDate),
      // todate: scheduleDate == null ? "" : scheduletodate == null ? convert(new Date()) : convert(scheduletodate),
      // key: loadMoreSearch
      rowsPerPage: 5,
      page: flag == 1 ? 1 : currentPage,
    }
    // console.log("active data", request);

    API.post("urcar_search/condition", request)
      .then((res) => {
        setSearchloading(false);

        if (res.data.success === true) {

          if (!make && !model && !year && !VINNumber && !InventoryNo && !status && !activecar && !bidStatus) {
            setSearchFlag(false)
          }

          const totalCount = res.data.data.length;
          const newTotalPages = Math.ceil(totalCount / pageLimit);
          let newCurrentPage = currentPage;
          if (newCurrentPage > newTotalPages) {
            newCurrentPage = newTotalPages;
          }
          const startIndex = (newCurrentPage - 1) * pageLimit;
          const endIndex = Math.min(currentPage * pageLimit, totalCount);

          const records = res.data.data
          setCarDetail(records);
          setTotalPages(Math.ceil(res.data.data1[0].count / 5));
          setTotalRecords([...Array(Math.ceil(res.data.data1[0].count / 5) + 1).keys()].slice(1))



          // setCarDetail(res.data.data);
          setLoadMoreSearch(res.data.data.length >= 8 ? res.data.data.length + 8 : loadMoreSearch)
          setUrCarDetailsCount(res.data.data.length)
          // console.log("setUrCarDetailsCount", res.data.data.length)
          setUrCarSearchCount(res.data.urcar_count);
          // setUrCarRefresh(true);

          // console.log("urcar_search data", res.data.data);
          if (res.data.data.length > 0) {
            setCarDetailForExcel(res.data.data.map(value => {
              return {
                vin_no: value.vin_no,
                inventory_no: value.inventory_no,
                model: value.model,
                make: value.make,
                year: value.year,
                // status:  value.sold
              }
            }))
          }
        }
        else {
          setErrors(res.data.error)
          setErrorFlag(true)
        }
      }).catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  const handleDateChangeRaw = (e) => {
    e.preventDefault();
  }

  const viewMoreredirectpage = (pathid) => {
    history.push({
      pathname: "/urcars",
      state: { urcarBack: "/urcar", id: pathid }
    });
  }
  const handleSellerDetailsName = (e) => {

    setDealerId(e.target.value)
    setSelectedSellerDetails(dealerList.filter(data => data.seller_dealer_id == e.target.value)[0])
    const selectedSellerDetails = dealerList.filter(data => data.seller_dealer_id == e.target.value)[0];
    getFiltercar(selectedSellerDetails);
    dispatch(DealerAction.searchrequest(selectedSellerDetails));

    // setselectSellerid(selectedSellerDetails.seller_dealer_id)
    setFalgFilter(true)

  }

  useEffect(() => {
    if (dealerData !== null) {

      getFiltercar(dealerData)
    }
  }, [])

  useEffect(() => {
    // console.log("id value",id)
    // urCarDetailsRefresh();
    getcar(dealerData)
    // let intervalId;
    // console.log("useefect outside")

    // intervalId = setInterval(() => {
    //   console.log("useefect Inside", urCarRefresh)

    //   getcar();
    //   // searchCarDetail();
    //   // urCarRefresh ? searchCarDetail() : getcar() 

    //     }, 30000)
    // return () => clearInterval(intervalId);
  }, [dealerData])

  const urCarLength = (data) => {
    let request = {
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

      // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data ,


      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
      // key:10
    }
    API.post('countDetails/condition', request).then(res => {
      if (res.data.success === true) {
        seturCarCount(res.data.data);
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }

    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
      }
    });
  }

  const loadMoreDetails = () => {

    if (urCarDetailsCount == false) {
      getcar(dealerData)

    }
    else {
      searchCarDetail(dealerData)

    }

  }


  useEffect(() => {
    urCarLength(dealerData);
  }, [dealerData]);

  // const urCarDetailsRefresh = () =>{

  //   if(urCarRefresh == false){
  //     // getcar()
  //     searchCarDetail()

  //   }
  //   else{
  //     // searchCarDetail()
  //     getcar()

  //   }

  //   }
  const handlePages = (page) => {
    // console.log(page, "records of list page");
    ls.set("currentpageopen1", page)
    setCurrentPage(page)
    setSearchFlag1(true)
  }
  const [carSearchTriggered, setCarSearchTriggered] = useState(false);
  // console.log("rocords carSearchTriggered", carSearchTriggered, searchFlag1, searchFlag);
  const handlePageChange = (newPage) => {
    // console.log(newPage, "records of list newPage");
    ls.set("currentpageopen1", newPage)
    setCurrentPage(newPage);
    setSearchFlag1(true)
  };
  const handlePageChangeDebounced = _.debounce(() => {
    if (!searchFlag1 && !searchFlag) {
      getcar(dealerData)
    }
    else if (searchFlag1 && searchFlag && !carSearchTriggered) {
      searchCarDetail(dealerData);
    } else if (searchFlag1 && !searchFlag) {
      getcar(dealerData)
    }
  }, 300);

  useEffect(() => {
    if (searchFlag || searchFlag1) {
      setCarSearchTriggered(false);
    }
  }, [searchFlag, searchFlag1]);
  useEffect(() => {

    handlePageChangeDebounced();
    // console.log("checking if in useEffect");
    return () => {
      handlePageChangeDebounced.cancel();
    };

  }, [currentPage]);
  const numberPattern = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setYear(value);
  };

  const getDealername = (data) => {

    let request = {
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    }
    API.post("dealerNameDynamic/condition", request).then(response => {
      if (response.data.success === true) {


        setDealerList(response.data.data);

      }

      else {
        setErrors(response.data.error.name)
        setErrorFlag(true)
      }


    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }

  const togglePrint = () => {
    setIsOpen(!isOpen);
  }

  const PrintData = (item) => {
    setCarId(item.carid);
    setYear(item.year);
    setMake(item.make);
    setModel(item.model);
    setVINNumber(item.vin_no);
    setInventoryNo(item.carid);

    togglePrint();
  }

  const printPage = (data) => {
    // console.log("print")
    printJS({
      printable: "pdfPage",
      type: 'html',
      targetStyles: ['*']
    })
  }

  const inputProps = {
    placeholder: "YYYY-MM-DD",
    value: scheduleDate
  };
  const inputProps1 = {
    placeholder: "YYYY-MM-DD",
    value: scheduletodate
  };
  const fromDate = (event) => {
    // console.log("from date", event);

    if (event._isAMomentObject == true) {
      setScheduleDate(event.format("YYYY-MM-DD"))
      setScheduleToDate("")
    }
  }
  const toDate = (event) => {
    // console.log("to date", event);
    if (event._isAMomentObject == true) {
      setScheduleToDate(event.format("YYYY-MM-DD"))
    }
  }
  const getFrmDtRemove = () => {
    setScheduleDate("")
    // setScheduleToDate("")
  }
  const getToDtRemove = () => {
    setScheduleToDate("")
  }

  useEffect(() => {
    getDealername();
    logedBuyerFees()
  }, []);

  const handleAfterChange = (currentSlide) => {

    // console.log(currentSlide, responsiveSettings[0].settings.slidesToShow, carDetail.length, "sdsdsdsdsd");
    if (currentSlide + responsiveSettings[0].settings.slidesToShow === carDetail.length - 1) {

      loadMoreDetails();

    }
  };


  const togglePopupBidList1 = (data) => {
    setBidId(data)
    togglePopupBidList()
  }
  const togglePopupBidList = () => {
    setisOpenBidList(!isOpenBidList);
  }
  const togglePopupCarHistory1 = (data) => {
    setBidId(data)
    togglePopupCarHistory()
  }
  const togglePopupCarHistory = () => {
    setIsOpenCarHistory(!isOpenCarHistory);
  }
  async function logedBuyerFees() {
    // console.log("inside fn");
    let request = {
      type: "Seller",
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    };
    const state = API.post('fees/condition', request);
    state.then(res => {
      // console.log("res", res)
      if (res.data.success === true) {
        setFeeDetails(res.data.data);
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }
    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }

  const [showPopover, setShowPopover] = useState(Array(carDetail.length).fill(false));
  const [carPrice, setCarPrice] = useState("")
  const [showPopoverIndex, setShowPopoverIndex] = useState(null);
  const [feeDetails, setFeeDetails] = useState("");

  const handleBackButtonClick = (index, item) => {
    // console.log(item, "item");
    setShowPopoverIndex(index === showPopoverIndex ? null : index);

    setShowPopover(prevShowPopover => {
      const newShowPopover = [...prevShowPopover];
      newShowPopover[index] = !newShowPopover[index];
      return newShowPopover;
    });
    setCarPrice(item)
  }
  const getFeeDetails = (maxPrice) => {
    // console.log("----fee---", maxPrice)

    return feeDetails.length > 0 ? feeDetails
      .filter((data) => {
        const range = data.from_price
        const rangeOne = data.to_price


        if (rangeOne !== "up") {

          return Number(range) <= Number(maxPrice) && Number(maxPrice) <= Number(rangeOne)
        }
        else {
          return Number(range) <= Number(maxPrice)
        }

      }
      )[0]?.fee || 0
      : 0


  }
  const totalPrice = Number(carPrice?.high_bid || 0) -
    (Number(getFeeDetails(carPrice?.high_bid || 0)) +
      Number(carPrice?.bos_sellerothertotalcharges || 0) +
      Number(carPrice?.bos_car_charges || 0));

  const TotalPriceForHighBid = (item) => {
    const data = Number(item.high_bid || 0) -
      (Number(getFeeDetails(item?.high_bid || 0)) +
        Number(item?.bos_sellerothertotalcharges || 0) +
        Number(item?.bos_car_charges || 0));
    return data
  }
const popover = (
  <Popover id="popover-basic" className="custom-popover">
    <Popover.Header as="h3" className="bg-danger text-white">Vehicle Price</Popover.Header>
    <Popover.Body>
      <div className="row">
        <div className="col-lg-12 pt-4 pt-lg-0 feestableBlock">
          <div className="feestable">
            <p>Price - <span>$ {carPrice?.high_bid || 0}</span></p>
            <p>Sell Fee - <span>$ {getFeeDetails(carPrice?.high_bid || 0)}</span></p>
            <p>Other Charges - <span>$ {carPrice?.bos_sellerothertotalcharges || 0}</span></p>
            <p>Miscellaneous Charges - <span>$ {carPrice?.bos_car_charges || 0}</span></p>
            <p>Total Price - <span>$ {totalPrice}</span></p>
          </div>
        </div>
      </div>
    </Popover.Body>
  </Popover>
);

  // clicks outside submenu close
  const handleOutsideClick = (event) => {
    if (!event.target.closest('.cars-prices')) {
      setShowPopoverIndex(null);
    }
  };


  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);


    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);
  const handleMagnifierMove = (e, imageUrl) => {
    const wrapper = e.currentTarget;
    const lens = wrapper.querySelector('.magnifier-lens');
    if (!lens) return;

    const rect = wrapper.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    lens.style.left = x + 'px';
    lens.style.top = y + 'px';

    const zoom = 2.5;
    const bgW = rect.width * zoom;
    const bgH = rect.height * zoom;
    const lR = lens.offsetWidth / 2;
    const bgX = (x / rect.width) * bgW - lR;
    const bgY = (y / rect.height) * bgH - lR;

    lens.style.backgroundImage = `url('${imageUrl}')`;
    lens.style.backgroundSize = `${bgW}px ${bgH}px`;
    lens.style.backgroundPosition = `-${bgX}px -${bgY}px`;
  };

  const handleMagnifierEnter = (e) => {
    const lens = e.currentTarget.querySelector('.magnifier-lens');
    if (lens) lens.style.display = 'block';
  };

  const handleMagnifierLeave = (e) => {
    const lens = e.currentTarget.querySelector('.magnifier-lens');
    if (lens) lens.style.display = 'none';
  };
// Change to this:
const exportToExcel = async () => {
  if (!carDetailForExcel || carDetailForExcel.length === 0) {
    alert('No data to export');
    return;
  }

  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('UR Cars');

    // Add headers
    worksheet.columns = [
      { header: 'VIN #', key: 'vin_no', width: 20 },
      { header: 'Model', key: 'model', width: 15 },
      { header: 'Make', key: 'make', width: 15 },
      { header: 'Year', key: 'year', width: 10 }
    ];

    // Add data
    carDetailForExcel.forEach(car => {
      worksheet.addRow({
        vin_no: car.vin_no || '',
        model: car.model || '',
        make: car.make || '',
        year: car.year || ''
      });
    });

    // Style the header row
    const headerRow = worksheet.getRow(1);
    headerRow.font = { bold: true };
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E0E0' }
    };

    // Generate Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { 
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    });
    saveAs(blob, `URCars_${new Date().toISOString().slice(0,10)}.xlsx`);
  } catch (error) {
    console.error('Export failed:', error);
    alert('Failed to export Excel file');
  }
};
  return (
    <>
      {loading ? <Loading /> :
        <main id="main" class="inner-page01">
          {errorFlag === true ? <PageNotFound error={errors} /> :
            <div id="historyPage" class="historyPage titleDuePage">
              <div class="container-fluid inner-page-space">


                <div class="common-heading">
                  <div className="row">
                    <div className="col-lg-4">
                      <div class="back-btn">
                        <a class="back-btn-primary" onClick={() => history.push("/carlist")}><i class="bx bx-chevron-left"></i> Back</a>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div class="title">
                        <p class="inner-title">URCars</p>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div class="title-dropdown">
                        <div class="tbox dealename-dropdown">
                          <select class="form-control box pad-ing " id="drop" placeholder="" className={`${dealerData != null ? (dealerData?.color == "pink"
                            ? "tableRowPink  form-control box"
                            : dealerData?.color == "firered"
                              ? "tableRowFireRed  form-control box"
                              : dealerData?.color == "green"
                                ? "tableRowGreenColor form-control box"
                                : dealerData?.color == "darkred"
                                  ? "tableRowRed1  form-control box"
                                  : " form-control box") :
                            (dealerList[0]?.color == "pink"
                              ? "tableRowPink  form-control box"
                              : dealerList[0]?.color == "firered"
                                ? "tableRowFireRed  form-control box"
                                : dealerList[0]?.color == "green"
                                  ? "tableRowGreenColor form-control box"
                                  : dealerList[0]?.color == "darkred"
                                    ? "tableRowRed1  form-control box"
                                    : " form-control box")
                            }`} onChange={handleSellerDetailsName}>
                            {dealerData != null ?
                              <option value={null} style={{ "display": "none" }}>{dealerData.dealer_name}({dealerData?.seller_dealer_id})</option> :
                              <option value={null} style={{ "display": "none" }}>{dealerList[0]?.dealer_name}({dealerList[0]?.seller_dealer_id})</option>}

                            {dealerList.length > 0 &&
                              <>
                                {dealerList.map((dealerList, index) => <option className={dealerList?.color == "pink"
                                  ? "tableRowPink  user_name"
                                  : dealerList?.color == "Silver"
                                    ? "tableRowSilver  user_name"
                                    : dealerList?.color == "Orange"
                                      ? "tableRowOrange  user_name"
                                      : dealerList?.color == "Navy blue"
                                        ? "tableRowNavyBlue  user_name"
                                        : dealerList?.color == "firered"
                                          ? "tableRowFireRed  user_name"
                                          : dealerList?.color == "Purple"
                                            ? "tableRowPurple  user_name"
                                            : dealerList?.color == "Yellow"
                                              ? "tableRowYellow1  user_name"
                                              : dealerList?.color == "green"
                                                ? "tableRowGreenColor user_name"
                                                : dealerList?.color == "blue"
                                                  ? "tableRowBlue  user_name"
                                                  : dealerList?.color == "darkred"
                                                    ? "tableRowRed1  user_name"
                                                    : dealerList?.color == "black"
                                                      ? "tableRowBlack1 user_name"
                                                      : " user_name"} key={dealerList.seller_dealer_id} value={dealerList.seller_dealer_id}  >{dealerList.dealer_name}({dealerList?.seller_dealer_id})</option>)}
                              </>
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="downBtn">
                  <i class="icofont-file-pdf"></i>
                  <button className="printBtn" type="button" onClick={() => printPage()}>Download</button>
                </div>
                <div class='download-btn'>
                  <div class="downBtn" onClick={exportToExcel}>
                    <i class="icofont-file-excel"></i>
                    <span>Export Excel</span>
                  </div>
                </div>

                <div class="lotfeeblock col-lg-12">
                  <div class="row content">
                    <div class="col-lg-12 col-md-12 col-sm-12 historyblock toggleList">
                      <div class="row">
                        <div className="col-lg-6 mb-0">
                          <p>{urCarDetailLength} of {urCarCount.urcar_count} UrCars</p>
                        </div>
                        <div className="col-lg-6">
                          {carDetail.length > 0 &&
                            <div class="multiAccept">
                              {allCarMultiAcceptEnable == true ? <span className="multiAcceptGrp"><button onClick={() => MultiAcceptDisable()}> Cancel </button>
                                <button onClick={() => togglePopupAccept()}> Accept </button>
                              </span> :

                                <button className="multiAcceptbtn" onClick={() => { setAllCarMultiAcceptEnable(true); setAllCarAcceptAllEnable(false); handleSelect() }}>Multi Accept</button>
                              }
                              {allCarAcceptAllEnable == true ? <span className="acceptAllGrp"><button onClick={() => AllAcceptDisable()}> Cancel </button>
                                <button onClick={() => togglePopupAccept()}> Accept </button>
                              </span> :

                                <button className="acceptAll" onClick={(e) => AllCarSelectBox(carDetail)} >Accept All</button>}
                            </div>
                          }
                        </div>

                        <div class="searchlistform col-lg-12">
                          <div class="searchblock">
                            <div className='row'>
                              <div class="form-group col-lg-2">
                                <label class="control-label" for="location">Year</label>
                                <input class="form-control border-end-0" type="text" id="location" placeholder="Enter Car Year" value={year}
                                  onChange={numberPattern} />
                              </div>
                              <div class="form-group col-lg-2">
                                <label class="control-label" for="dealername">Make</label>
                                <input class="form-control border-end-0" type="text" id="dealername" placeholder="Enter Car Make"
                                  onChange={(e) => setMake(e.target.value)} />
                              </div>

                              <div class="form-group col-lg-2">
                                <label class="control-label" for="dealername">Model</label>
                                <input class="form-control border-end-0" type="text" id="dealername" placeholder="Enter Car Model"
                                  onChange={(e) => setModel(e.target.value)} />
                              </div>

                              <div class="form-group col-lg-2 ">
                                <label class="control-label" for="date">Vin #</label>
                                <input class="form-control border-end-0 " type="text" id="date" placeholder="Enter Vin Number"
                                  onChange={(e) => setVINNumber(e.target.value)} />
                              </div>

                              <div class="form-group carStatus col-lg-2">
                                <label class="control-label" for="dealername">Car Status</label>
                                <select id="drop" placeholder="Car Status" name="dropoption" className="form-control border-end-0 csSelect"
                                  onChange={(e) => setActivecar(e.target.value)}>
                                  <option value="Select">-- Select --</option>
                                  <option value="1">Running</option>
                                  <option value="0">Not Running</option>
                                </select>
                              </div>

                              <div class="form-group carStatus col-lg-2">
                                <label class="control-label" for="dealername">Sold Status</label>
                                <select id="drop" placeholder="Car Status" name="dropoption" className="form-control border-end-0 csSelect"
                                  onChange={(e) => setStatus(e.target.value)}>
                                  <option value="Select">-- Select --</option>
                                  <option value="sold">sold</option>
                                  <option value="running">unsold</option>
                                </select>
                              </div>
                              <div class="form-group carStatus col-lg-2">
                                <label class="control-label" for="dealername">Bid Status</label>
                                <select id="drop" placeholder="Car Status" name="dropoption" className="form-control border-end-0 csSelect"
                                  onChange={(e) => setBidStatus(e.target.value)}>
                                  <option value="Select">-- Select --</option>
                                  <option value="Make Bid">Make Bid</option>
                                  <option value="Sealed Bid Sales">Sealed Bid</option>
                                </select>
                              </div>
                              <div className="form-group dateBlock col-lg-2">
                                <label className="control-label" for="date">From Date</label>
                                <div className="history-date-row">
                                  <Datetime closeOnSelect={true} inputProps={inputProps} timeFormat={false} dateFormat="YYYY-MM-DD"
                                    name="Date" onChange={fromDate} id="meeting_date1" />
                                  {scheduleDate &&
                                    <img src={wrong} className="history-date-img" onClick={getFrmDtRemove} />
                                  }
                                </div>
                              </div>
                              <div className="form-group dateBlock col-lg-2">
                                <label title=" Select From date first to proceed !" className="control-label" for="todate">To Date</label>
                                <div className="history-date-row">
                                  <Datetime closeOnSelect={true} inputProps={inputProps1} timeFormat={false} dateFormat="YYYY-MM-DD"
                                    name="Date" isValidDate={disablePastDt} onChange={toDate} id="meeting_date2" />
                                  {scheduletodate &&
                                    <img src={wrong} className="history-date-img" onClick={getToDtRemove} />
                                  }
                                </div>
                              </div>

                              <div class="form-group col-lg-2">
                                <label class="control-label" for="location">Inventory #</label>
                                <input class="form-control border-end-0" type="text" id="dealername" placeholder="Enter Inventory #"
                                  onChange={(e) => setInventoryNo(e.target.value)} />

                              </div>
                              <div class=" form-group searchbtn col-lg-2">
                                {/*<img src={searchicon} onClick={searchCarDetail}/>*/}
                                <button onClick={() => {
                                  searchCarDetail(dealerData, 1);
                                  setSearchloading(true); setSearchFlag(true); setCurrentPage(1)
                                }}><i class="bx bx-search"></i></button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="errorMsgBox col-lg-12">
                          <p className="form-input-error" >{vinError}</p>
                          <p className="form-input-error" >{fromDateError}</p>
                        </div>



                        <div class="col-lg-12  hisHead">
                          {urCarDetailsCount == "" || urCarDetailsCount == null || urCarDetailsCount == undefined ? "" :
                            <p>{urCarDetailsCount} of {urCarSearchCount} vehicles Found</p>}
                        </div>

                      </div>
                      {window.innerWidth >= 992 ? (
                        <div
                          class="row aos-init aos-animate"
                          data-aos="zoom-in"
                          data-aos-delay="100"
                        >
                          {carDetail.length > 0 ? carDetail
                            .map((item, index) =>

                              <div class="col-lg-4" >
                                {item.isActive === "1" ?
                                  <div class="car-item ">


                                    {item.status == "sold" || item.high_bid == "" || item.high_bid == null || item.high_bid == undefined || item.high_bid == 0 || item.isActive == 0 || item.label_type == "Sealed Bid Sales" ? "" :
                                      <div>
                                        {allCarMultiAcceptEnable &&
                                          <div className="custom_checkbox">
                                            <input type="checkbox" id={`allCarSelect${index}`} onClick={(e) => allCarSelectBox(`allCarSelect${index}`, item)} />
                                            <label for={`allCarSelect${index}`}></label>
                                          </div>
                                        }
                                      </div>}
                                    {(item.status == "sold" || item.high_bid == "" || item.high_bid == null || item.high_bid == undefined || item.high_bid == 0 || item.isActive == 0 || item.label_type == "Sealed Bid Sales" ? "" :
                                      allCarAcceptAllEnable) &&
                                      <div className="custom_checkbox">
                                        <input type="checkbox" checked="true" id={`allCarSelected${index}`} />
                                        <label for={`allCarSelected${index}`}></label>
                                      </div>
                                    }
                                    <div
                                      className="carImg-wrapper"
                                      onMouseMove={(e) => handleMagnifierMove(e, item.image)}
                                      onMouseEnter={handleMagnifierEnter}
                                      onMouseLeave={handleMagnifierLeave}
                                    >
                                      <img onClick={() => { item.isActive === "1" ? redirectpage(item.carid, item, item.seller_dealer_id, item.transportation_flag) : rerunCarPage(item.carid, item, item.seller_dealer_id) }} src={item.image} class="carImg" alt="..." />
                                      <div className="magnifier-lens" />
                                    </div>
                                    <div /* onClick={() => { item.isActive === "1" ? redirectpage(item.carid, item, item.seller_dealer_id, item.transportation_flag) : rerunCarPage(item.carid, item, item.seller_dealer_id) }}  */ class="cars-content">


                                      <div class="cars-content">
                                        <h3>
                                          <a>
                                            {item.year} {item.make} {item.model}
                                          </a>
                                        </h3>

                                        <div class="d-flex align-items-center mb-3">
                                          <p class="details">
                                            <img src={speedometer} alt="" />
                                            <span>{item.mileage} {item.mileage_type}</span>
                                          </p>
                                          {item.fuel_type == "null" ||
                                            item.fuel_type == null ||
                                            item.fuel_type == "" ||
                                            item.fuel_type == "undefined" ||
                                            item.fuel_type == undefined
                                            ? ""
                                            :
                                            <p class="details">
                                              <img src={gasolinePump} alt="" />
                                              <span>
                                                {item.fuel_type}
                                              </span>
                                            </p>}
                                        </div>
                                        <div class="d-flex align-items-center mb-3">
                                          <p class="details"><img src={odometer} alt="" /><span>Odometer</span>:&nbsp;{item.odometer == "null" || item.odometer == null || item.odometer == "undefined" || item.odometer == undefined ? "" : item.odometer}</p>
                                        </div>



                                        <a class="labeltype"><span>{item.label_type === "Sealed Bid Sales" ? item.label_type.substr(0, 10) : item.label_type}</span></a>
                                        {item.label_type === "Sealed Bid Sales" ?
                                          <a class="cars-buy-btns redBtn butnpad ms-5" onClick={() => togglePopupCarHistory1(item.carid)} >Bid Details</a> :
                                          <a class="cars-buy-btns redBtn butnpad ms-5" onClick={() => togglePopupBidList1(item.carid)} >Bid Details</a>
                                        }

                                      </div>

                                      {item.status == "sold" ?
                                        <div class="cars-prices">
                                          <div class="prices">
                                            <a class="cta-btns SellPrice" >Sold : <span> $ {item.max_price} </span></a>
                                          </div></div>
                                        :
                                        <>
                                          {item.sales_type_id == 1 ? "" :
                                            <div class="cars-prices">
                                              {item.min_price == "" || item.min_price == undefined || item.min_price == null ? "" :
                                                <div class="prices">
                                                  <a class="cta-btns highBid" >Minimum Bid : <span> $ {item.min_price}</span></a>
                                                </div>}
                                              {item.max_price == "" || item.max_price == undefined || item.max_price == null ? "" :
                                                <div class="prices">
                                                  <a class="cta-btns SellPrice" >Sell it now : <span> $ {item.max_price} </span></a>
                                                </div>}
                                              {item.high_bid == "" || item.high_bid == undefined || item.high_bid == null ? "" :
                                                <div class="prices">
                                                  <a class="cta-btns highBid me-2" >High Bid : <span> $ {TotalPriceForHighBid(item)}</span></a>
                                                  <OverlayTrigger
                                                    trigger="click"
                                                    placement="top"
                                                    show={showPopoverIndex === index}
                                                    overlay={popover}
                                                  >
                                                    <Button onClick={() => handleBackButtonClick(index, item,)} variant="primary"><FontAwesomeIcon icon={faInfo} />   </Button>
                                                  </OverlayTrigger>


                                                </div>}

                                            </div>}
                                        </>
                                      }
                                    </div>

                                  </div> :
                                  <div class="car-item runout">
                                    <div class="runoutOverlay"></div>

                                    <div
                                      className="carImg-wrapper"
                                      onMouseMove={(e) => handleMagnifierMove(e, item.image)}
                                      onMouseEnter={handleMagnifierEnter}
                                      onMouseLeave={handleMagnifierLeave}
                                    >
                                      <img onClick={() => { item.isActive === "1" ? redirectpage(item.carid, item, item.seller_dealer_id, item.transportation_flag) : rerunCarPage(item.carid, item, item.seller_dealer_id) }} src={item.image} class="carImg" alt="..." />
                                      <div className="magnifier-lens" />
                                    </div>
                                    <div onClick={() => { item.isActive === "1" ? redirectpage(item.carid, item, item.seller_dealer_id, item.transportation_flag) : rerunCarPage(item.carid, item, item.seller_dealer_id) }} class="runoutContent">
                                      <p>Its not running now</p>
                                      <div class="text-center"><a class="redBtn carHistory">Run it</a></div>
                                    </div>


                                    <div class="cars-content">
                                      <h3>
                                        <a>
                                          {item.year} {item.make} {item.model}
                                        </a>
                                      </h3>
                                      {/* <div className='cars-popover'>

                                        <OverlayTrigger
                                          trigger="click"
                                          placement="top"
                                          show={showPopover[index]}
                                          overlay={popover}
                                        >
                                          <Button onClick={() => handleBackButtonClick(index, item,)} variant="primary">Click </Button>
                                        </OverlayTrigger>

                                      </div> */}
                                      <div class="d-flex align-items-center mb-3">
                                        <p class="details">
                                          <img src={speedometer} alt="" />
                                          <span>{item.mileage} {item.mileage_type}</span>
                                        </p>
                                        {item.fuel_type == "null" ||
                                          item.fuel_type == null ||
                                          item.fuel_type == "" ||
                                          item.fuel_type == "undefined" ||
                                          item.fuel_type == undefined
                                          ? ""
                                          :
                                          <p class="details">
                                            <img src={gasolinePump} alt="" />
                                            <span>
                                              {item.fuel_type}
                                            </span>
                                          </p>}
                                      </div>
                                      <div class="d-flex align-items-center mb-3">
                                        <p class="details"><img src={odometer} alt="" /><span>Odometer</span>:&nbsp;{item.odometer == "null" || item.odometer == null || item.odometer == "undefined" || item.odometer == undefined ? "" : item.odometer}</p>
                                      </div>



                                      <a class="labeltype"><span>{item.label_type === "Sealed Bid Sales" ? item.label_type.substr(0, 10) : item.label_type}</span></a>

                                    </div>


                                    {item.status == "sold" ?
                                      <div class="cars-prices">
                                        <div class="prices">
                                          <a class="cta-btns SellPrice" >Sold : <span> $ {item.sold_price} </span></a>
                                        </div></div> :
                                      <div class="cars-prices">

                                        {item.high_bid == "" || item.high_bid == undefined || item.high_bid == null ? "" :

                                          <div class="prices">
                                            <a class="cta-btns highBid" >High Bid : <span> $ {item.high_bid}</span></a>
                                          </div>}
                                      </div>}
                                  </div>}
                              </div>) :

                            <div class="col-lg-12 nodata"><p>No Data Found</p> </div>}
                          <div class="text-center col-lg-12">
                            {carDetail.length >= 8 ? carDetail.slice(0, 1).map(() =>
                              <a onClick={loadMoreDetails} class={carDetail.length !== urCarCount.urcar_count && urCarDetailsCount !== urCarSearchCount ? "load-more-btn" : ""}>{carDetail.length !== urCarCount.urcar_count && urCarDetailsCount !== urCarSearchCount ? "Load More" : ""}</a>
                            ) : ""} </div>

                        </div>
                      ) : (
                        <>
                          {Searchloading ? <Loading /> :
                            <div className='row'>
                              {carDetail?.length > 0 ? (

                                <Slider
                                  dots={false}
                                  infinite={false}
                                  speed={500}
                                  responsive={responsiveSettings}
                                  centerMode={false}
                                  afterChange={handleAfterChange}
                                >

                                  {carDetail
                                    .map((item, index) =>

                                      <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6" >
                                        {item.isActive === "1" ?
                                          <div class="car-item ">


                                            {item.status == "sold" || item.high_bid == "" || item.high_bid == null || item.high_bid == undefined || item.high_bid == 0 || item.isActive == 0 ? "" :
                                              <div>
                                                {allCarMultiAcceptEnable &&
                                                  <div className="custom_checkbox">
                                                    <input type="checkbox" id={`allCarSelect${index}`} onClick={(e) => allCarSelectBox(`allCarSelect${index}`, item)} />
                                                    <label for={`allCarSelect${index}`}></label>
                                                  </div>
                                                }
                                              </div>}
                                            {(item.status == "sold" || item.high_bid == "" || item.high_bid == null || item.high_bid == undefined || item.high_bid == 0 || item.isActive == 0 ? "" :
                                              allCarAcceptAllEnable) &&
                                              <div className="custom_checkbox">
                                                <input type="checkbox" checked="true" id={`allCarSelected${index}`} />
                                                <label for={`allCarSelected${index}`}></label>
                                              </div>
                                            }
                                            <div
                                              className="carImg-wrapper"
                                              onMouseMove={(e) => handleMagnifierMove(e, item.image)}
                                              onMouseEnter={handleMagnifierEnter}
                                              onMouseLeave={handleMagnifierLeave}
                                            >
                                              <img onClick={() => { item.isActive === "1" ? redirectpage(item.carid, item, item.seller_dealer_id, item.transportation_flag) : rerunCarPage(item.carid, item, item.seller_dealer_id) }} src={item.image} class="carImg" alt="..." />
                                              <div className="magnifier-lens" />
                                            </div>
                                            <div /* onClick={() => { item.isActive === "1" ? redirectpage(item.carid, item, item.seller_dealer_id, item.transportation_flag) : rerunCarPage(item.carid, item, item.seller_dealer_id) }} */ class="cars-content">
                                              <div class="cars-content">
                                                <h3>
                                                  <a href="#">
                                                    {item.year} {item.make} {item.model}
                                                  </a>
                                                </h3>
                                                {/*  <div className='cars-popover'>

                                                  <OverlayTrigger
                                                    trigger="click"
                                                    placement="top"
                                                    show={showPopover[index]}
                                                    overlay={popover}
                                                  >
                                                    <Button onClick={() => handleBackButtonClick(index, item,)} variant="primary">Click </Button>
                                                  </OverlayTrigger>

                                                </div> */}
                                                <div class="d-flex align-items-center mb-3">
                                                  <p class="details">
                                                    <img src={speedometer} alt="" />
                                                    <span>{item.mileage} {item.mileage_type}</span>
                                                  </p>
                                                  &nbsp;&nbsp;&nbsp;&nbsp;
                                                  {item.fuel_type == "null" ||
                                                    item.fuel_type == null ||
                                                    item.fuel_type == "" ||
                                                    item.fuel_type == "undefined" ||
                                                    item.fuel_type == undefined
                                                    ? ""
                                                    :
                                                    <p class="details">
                                                      <img src={gasolinePump} alt="" />
                                                      <span>
                                                        {item.fuel_type}
                                                      </span>
                                                    </p>}
                                                </div>
                                                <div class="d-flex align-items-center mb-3">
                                                  <p class="details"><img src={odometer} alt="" /><span>Odometer</span>:&nbsp;{item.odometer == "null" || item.odometer == null || item.odometer == "undefined" || item.odometer == undefined ? "" : item.odometer}</p>
                                                </div>
                                              </div>
                                              {item.label_type === "Sealed Bid Sales" ?
                                                <a class="cars-buy-btns redBtn butnpad " onClick={() => togglePopupCarHistory1(item.carid)} >Bid Details</a> :
                                                <a class="cars-buy-btns redBtn butnpad" onClick={() => togglePopupBidList1(item.carid)} >Bid Details</a>
                                              }
                                              {item.status == "sold" ?
                                                <div class="cars-prices">
                                                  <div class="prices">
                                                    <a class="cta-btns SellPrice" >Sold : <span> $ {item.max_price} </span></a>
                                                  </div></div>
                                                :
                                                <>
                                                  {item.sales_type_id == 1 ? "" :
                                                    <div class="cars-prices" >
                                                      {item.min_price == "" || item.min_price == undefined || item.min_price == null ? "" :
                                                        <div class="prices">
                                                          <a class="cta-btns highBid" >Minimum Bid : <span> $ {item.min_price}</span></a>
                                                        </div>}
                                                      {item.max_price == "" || item.max_price == undefined || item.max_price == null ? "" :
                                                        <div class="prices">
                                                          <a class="cta-btns SellPrice" >Sell it now : <span> $ {item.max_price} </span></a>
                                                        </div>}
                                                      {item.high_bid == "" || item.high_bid == undefined || item.high_bid == null ? "" :
                                                        <div class="prices">
                                                          <a class="cta-btns highBid" >High Bid : <span> $ {TotalPriceForHighBid(item)}</span></a>
                                                          <OverlayTrigger
                                                            trigger="click"
                                                            placement="top"
                                                            show={showPopoverIndex === index}
                                                            overlay={popover}
                                                          >
                                                            <Button onClick={() => handleBackButtonClick(index, item,)} variant="primary"><FontAwesomeIcon icon={faInfo} />   </Button>
                                                          </OverlayTrigger>
                                                        </div>}

                                                    </div>}
                                                </>
                                              }
                                            </div>
                                          </div> :
                                          <div class="car-item runout">
                                            <div class="runoutOverlay"></div>

                                            <div
                                              className="carImg-wrapper"
                                              onMouseMove={(e) => handleMagnifierMove(e, item.image)}
                                              onMouseEnter={handleMagnifierEnter}
                                              onMouseLeave={handleMagnifierLeave}
                                            >
                                              <img onClick={() => { item.isActive === "1" ? redirectpage(item.carid, item, item.seller_dealer_id, item.transportation_flag) : rerunCarPage(item.carid, item, item.seller_dealer_id) }} src={item.image} class="carImg" alt="..." />
                                              <div className="magnifier-lens" />
                                            </div>
                                            <div onClick={() => { item.isActive === "1" ? redirectpage(item.carid, item, item.seller_dealer_id, item.transportation_flag) : rerunCarPage(item.carid, item, item.seller_dealer_id) }} class="runoutContent">
                                              <p>Its not running now</p>
                                              <div class="text-center"><a class="redBtn carHistory">Run it</a></div>
                                            </div>
                                            <div class="cars-content">
                                              <h3>
                                                <a href="#">
                                                  {item.year} {item.make} {item.model}
                                                </a>
                                              </h3>
                                              {/* <div className='cars-popover'>

                                                <OverlayTrigger
                                                  trigger="click"
                                                  placement="top"
                                                  show={showPopover[index]}
                                                  overlay={popover}
                                                >
                                                  <Button onClick={() => handleBackButtonClick(index, item,)} variant="primary">Click </Button>
                                                </OverlayTrigger>

                                              </div> */}
                                              <div class="d-flex align-items-center mb-3">
                                                <p class="details">
                                                  <img src={speedometer} alt="" />
                                                  <span>{item.mileage} {item.mileage_type}</span>
                                                </p>
                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                                {item.fuel_type == "null" ||
                                                  item.fuel_type == null ||
                                                  item.fuel_type == "" ||
                                                  item.fuel_type == "undefined" ||
                                                  item.fuel_type == undefined
                                                  ? ""
                                                  :
                                                  <p class="details">
                                                    <img src={gasolinePump} alt="" />
                                                    <span>
                                                      {item.fuel_type}
                                                    </span>
                                                  </p>}
                                              </div>
                                              <div class="d-flex align-items-center mb-3">
                                                <p class="details"><img src={odometer} alt="" /><span>Odometer</span>:&nbsp;{item.odometer == "null" || item.odometer == null || item.odometer == "undefined" || item.odometer == undefined ? "" : item.odometer}</p>
                                              </div>


                                              {item.status == "sold" ?
                                                <div class="cars-prices">
                                                  <div class="prices">
                                                    <a class="cta-btns SellPrice" >Sold : <span> $ {item.sold_price} </span></a>
                                                  </div></div> :
                                                <div class="cars-prices">

                                                  {item.high_bid == "" || item.high_bid == undefined || item.high_bid == null ? "" :

                                                    <div class="prices">
                                                      <a class="cta-btns highBid" >High Bid : <span> $ {item.high_bid}</span></a>
                                                    </div>}
                                                </div>}
                                            </div>
                                          </div>
                                        }
                                      </div>)}
                                </Slider>)

                                :

                                <div class="col-lg-12 nodata"><p>No Data Found</p> </div>}

                            </div>
                          }
                        </>
                      )
                      }
                      <div className="col-lg-12 tablePagination d-flex justify-content-center mt-4">
                        <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} totalRecords={totalRecords} handlePages={handlePages} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div >}



          {
            isOpenAccept && <Popup
              isClose={false}
              content={<>
                <AcceptedCars toggle={togglePopupAccept} carId={checkedCarId} buyerId={buyerId} highBid={highBid} transportationCharge={transportationCharge} handleClose1={handleClose1}
                  buyerDealerId={buyerDealerId} />
              </>}
              handleClose={togglePopupAccept}
            />
          }

          {isOpenCarHistory && <Popup
            isClose={false}
            content={<>
              <SealedBidHome toggle={togglePopupCarHistory} carId={bidId} />
            </>}
            handleClose={togglePopupCarHistory}
          />}
          {isOpenBidList && <Popup
            isClose={false}
            content={<>
              <UrCarBidList toggle={togglePopupBidList} carId={bidId}/*  time={time} countBid={countBid} newBid={newBid} */ />
            </>}
            handleClose={togglePopupBidList}
          />}
        </main >
      }
      <section id="playstoreBlock" class="playstoreBlock">
        <div class="container">


          <div class="row content">
            <div class="col-lg-12">
              <img src={appstore} />
              <img src={googleplay} />

            </div>

          </div>

        </div>
      </section>
      <div>
        < div class="hideContent" >
          <div id="pdfPage" style={{ "border-collapse": "collapse" }}>
            <div className="section-title">
              <h2>Car Details</h2>
            </div>
            <div class="sellerChargesListtable table-responsive">
              <div className="abletable">
                <table>
                  <thead>
                    <tr>
                      <td><b>Vin # </b></td>
                      <td><b>Model </b></td>
                      <td><b>Make </b></td>
                      <td><b>Year</b> </td>
                    </tr>
                  </thead>

                  {carDetail?.length > 0 ? carDetail.map((item) =>
                    <tr>
                      <td>{item.vin_no}</td>
                      <td>{item.model}</td>
                      <td>{item.make}</td>

                      <td>{item.year}</td>

                    </tr>) : ""}

                </table>
              </div>
            </div>
          </div>

        </div>
      </div>

    </>
  )
}

export default URcar;
